const inputs = document.querySelectorAll("#page-filters select");

inputs.forEach(function(input) {
    input.addEventListener('change', function() {
        this.form.submit();
    })
});
